// Direct <head> management.
// react-helmet 6 is inert under React 18 + StrictMode (it renders nothing into
// the head), which left every page with the static title, description and
// canonical from public/index.html — so Google Analytics reported every article
// as the home page. These helpers write the tags themselves.

export var SITE_URL = 'https://mamanalgerienne.com';
export var SITE_NAME = 'Maman Algérienne';
export var DEFAULT_TITLE = 'Maman Algérienne | ماما الجزائرية - مجتمع الأمهات الجزائريات';
export var DEFAULT_DESCRIPTION = 'ماما الجزائرية - المجتمع الأول للأمهات الجزائريات. نصائح الحمل والأمومة، وصفات جزائرية، تربية الأطفال، صحة الأم والطفل.';

function setTag(selector, create, content) {
  if (!content) return;
  var el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(el.tagName === 'LINK' ? 'href' : 'content', content);
}

function setMetaName(name, content) {
  setTag('meta[name="' + name + '"]', function () {
    var m = document.createElement('meta');
    m.setAttribute('name', name);
    return m;
  }, content);
}

function setMetaProperty(property, content) {
  setTag('meta[property="' + property + '"]', function () {
    var m = document.createElement('meta');
    m.setAttribute('property', property);
    return m;
  }, content);
}

function setCanonical(url) {
  setTag('link[rel="canonical"]', function () {
    var l = document.createElement('link');
    l.setAttribute('rel', 'canonical');
    return l;
  }, url);
}

// meta: { title, description, image, url, type }
export function setPageMeta(meta) {
  var title = meta.title || DEFAULT_TITLE;
  var description = meta.description || DEFAULT_DESCRIPTION;
  var url = meta.url || SITE_URL;

  document.title = title;
  setMetaName('description', description);
  setCanonical(url);

  setMetaProperty('og:title', title);
  setMetaProperty('og:description', description);
  setMetaProperty('og:url', url);
  setMetaProperty('og:type', meta.type || 'website');
  if (meta.image) setMetaProperty('og:image', meta.image);

  setMetaName('twitter:title', title);
  setMetaName('twitter:description', description);
  if (meta.image) setMetaName('twitter:image', meta.image);
}
